import React from 'react';
import {RoutePermittedPath} from 'shared/constants/AppEnums';
const Avaluos = React.lazy(() => import('./Avaluo'));
export const avaluosPagesConfigs = [
  {
    permittedPath: RoutePermittedPath.avaluos,
    path: '/avaluos',
    element: <Avaluos />,
  },
];